import { render, staticRenderFns } from "./examSingUp.vue?vue&type=template&id=34af1afa"
import script from "./examSingUp.vue?vue&type=script&lang=js"
export * from "./examSingUp.vue?vue&type=script&lang=js"
import style0 from "./examSingUp.vue?vue&type=style&index=0&id=34af1afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports